<ui-popover popover anchorName="--nav-locations" initPosition="RIGHT" #tutorialPopover>
  <ui-simple-popover-layout (clickClose)="tutorialPopover.hide()">
    <h2 slot="title" class="font-semibold leading-6 line-clamp-1">
      {{ 'help.locations.lumoLearnPopover.title' | transloco }}
    </h2>
    <p class="max-w-60">{{ 'help.locations.lumoLearnPopover.description' | transloco }}</p>
    <div slot="footer" class="flex justify-end">
      <ui-button mode="outlined" size="small" (click)="tutorialDialog.showModal()">
        {{ 'help.locations.lumoLearnPopover.showButton' | transloco }}
        <ng-icon name="heroArrowRight" size="20" slot="end" class="!block" />
      </ui-button>
    </div>
  </ui-simple-popover-layout>
</ui-popover>

<ui-simple-dialog #tutorialDialog [lazy]="true">
  <ui-simple-dialog-layout class="w-full" (clickCancel)="tutorialDialog.close()">
    <h2 slot="title" class="font-semibold leading-6 line-clamp-1">
      {{ 'help.locations.lumoLearnPopover.title' | transloco }}
    </h2>
    <app-youtube-embed [url]="embedVideoUrl" />
    <div slot="footer" class="flex justify-end gap-3">
      <a
        href="#"
        target="_blank"
        [title]="'help.locations.lumoLearnPopover.helpCenterButton' | transloco"
        *appFeatureEnabled="'helpCenter'"
      >
        <ui-button mode="outlined">
          {{ 'help.locations.lumoLearnPopover.helpCenterButton' | transloco }}
        </ui-button>
      </a>
      <ui-button (click)="tutorialDialog.close()">
        {{ 'help.locations.lumoLearnPopover.closeButton' | transloco }}
      </ui-button>
    </div>
  </ui-simple-dialog-layout>
</ui-simple-dialog>
